import { UPDATE_FRONT_STYLE_ONSTREET_DELIVERY } from "./frontStyleOnstreetDeliveryReducer"

export const updateFrontStyleOnstreetDelivery = (status) => ({
    type: UPDATE_FRONT_STYLE_ONSTREET_DELIVERY,
    payload: status
})
